const themes = [
  "vw",
  "vwtransportbilar",
  "audi",
  "seat",
  "skoda",
  "cupra",
] as const;
export default themes;
export type ValidTheme = (typeof themes)[number] | "default";
